import { createAction } from 'redux-actions';
import {
  CHARTIQ_STUDY_ADD_STUDY,
  CHARTIQ_STUDY_ADD_STUDY_AND_SAVE,
  CHARTIQ_STUDY_CLOSE_STUDY_MODAL,
  CHARTIQ_STUDY_OPEN_STUDY_MODAL,
  CHARTIQ_STUDY_REMOVE_STUDY,
  CHARTIQ_STUDY_REMOVE_STUDY_AND_SAVE,
  CHARTIQ_STUDY_SET_STUDY_HELPER,
  CHARTIQ_STUDY_TOGGLE_STUDY_OVERLAY,
  CHARTIQ_STUDY_UPDATE_STUDY,
  CHARTIQ_STUDY_UPDATE_STUDY_AND_SAVE,
} from './constants';

export const addStudy = createAction(
  CHARTIQ_STUDY_ADD_STUDY,
  (params: any) => params,
);

export const addStudyAndSave = createAction(
  CHARTIQ_STUDY_ADD_STUDY_AND_SAVE,
  (params: any) => params,
);

export const closeStudyModal = createAction(
  CHARTIQ_STUDY_CLOSE_STUDY_MODAL,
  (params: any) => params,
);

export const openStudyModal = createAction(
  CHARTIQ_STUDY_OPEN_STUDY_MODAL,
  (params: any) => params,
);

export const removeStudy = createAction(
  CHARTIQ_STUDY_REMOVE_STUDY,
  (params: any) => params,
);

export const removeStudyAndSave = createAction(
  CHARTIQ_STUDY_REMOVE_STUDY_AND_SAVE,
  (params: any) => params,
);

export const setStudyHelper = createAction(
  CHARTIQ_STUDY_SET_STUDY_HELPER,
  (params: any) => params,
);

export const toggleOverlay = createAction(
  CHARTIQ_STUDY_TOGGLE_STUDY_OVERLAY,
  (params: any) => params,
);

export const updateStudy = createAction(
  CHARTIQ_STUDY_UPDATE_STUDY,
  (params: any) => params,
);

export const updateStudyAndSave = createAction(
  CHARTIQ_STUDY_UPDATE_STUDY_AND_SAVE,
  (params: any) => params,
);
